/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Col_SyncInputs */

const cs_projects_col_sync = /** @type {(inputs: Projects_Col_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync`)
};

const en_projects_col_sync = /** @type {(inputs: Projects_Col_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync`)
};

/**
* | output |
* | --- |
* | "Sync" |
*
* @param {Projects_Col_SyncInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_col_sync = /** @type {((inputs?: Projects_Col_SyncInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Col_SyncInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_col_sync(inputs)
	return cs_projects_col_sync(inputs)
});